module.exports = __webpack_public_path__ + "img/53fb1a9dd4e8a873c6420acf1d2ff07.7bccdeb8.png";